// @ts-nocheck

import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../../types/basket';
import { BetslipTypes } from '../../../types/history';

export default (state, action, { entities }) => {
  const { status } = state;
  const { matches, tournaments, categories } = entities;
  const { betslipType, betAmount, items, betslipId, isFromFreebets } = action.payload;
  // can't set cashout while pending status
  if (status !== BasketStatuses.PENDING) {
    const nextItems = items.reduce((prev, item, i) => {
      let sportId = undefined;
      if (matches[item.matchId] && matches[item.matchId].tournamentId) {
        const tournament = tournaments[matches[item.matchId].tournamentId];
        if (tournament && tournament.categoryId) {
          const category = categories[tournament.categoryId];
          sportId = category.sportId;
        }
      }

      prev[item.outcomeId] = {
        betbuilder: item.betbuilder,
        status: BasketItemStatuses.OK,
        oddId: item.outcomeId,
        betId: item.betId,
        matchId: item.matchId,
        value: item.odds,
        selectionItems: item.selectionItems,
        sportId,
        banker: false,
        stake: betAmount,
        sortBy: i,
        cashout: true,
        selectedFreebetId: undefined,
      };
      return prev;
    }, {});
    return {
      ...state,
      items: nextItems,
      isCashout: true,
      cashoutBetslipType: betslipType,
      cashoutBetslipId: betslipId,
      mode: betslipType === BetslipTypes.SINGLE ? BasketModes.SIMPLE : BasketModes.COMBINED,
      eligibleBooster: {},
      eligibleFreebets: {},
      stake: betAmount,
      selectedFreebetId: undefined,
      isFromFreebets,
    };
  }
  return state;
};
